import * as $ from 'jquery';
import TranslationsService from '../services/translationsService';

// Init translations
const translationsService = TranslationsService.getInstance();
translationsService.addTranslations('translations');

const countries = [{
	value: 'USA', label: 'USA', states: [
		{value: 'AL', label: 'Alabama'},
		{value: 'AK', label: 'Alaska'},
		{value: 'AZ', label: 'Arizona'},
		{value: 'AR', label: 'Arkansas'},
		{value: 'CA', label: 'California'},
		{value: 'CO', label: 'Colorado'},
		{value: 'CT', label: 'Connecticut'},
		{value: 'DE', label: 'Delaware'},
		{value: 'DC', label: 'District of Columbia'},
		{value: 'FL', label: 'Florida'},
		{value: 'GA', label: 'Georgia'},
		{value: 'HI', label: 'Hawaii'},
		{value: 'ID', label: 'Idaho'},
		{value: 'IL', label: 'Illinois'},
		{value: 'IN', label: 'Indiana'},
		{value: 'IA', label: 'Iowa'},
		{value: 'KS', label: 'Kansas'},
		{value: 'KY', label: 'Kentucky'},
		{value: 'LA', label: 'Louisiana'},
		{value: 'ME', label: 'Maine'},
		{value: 'MD', label: 'Maryland'},
		{value: 'MA', label: 'Massachusetts'},
		{value: 'MI', label: 'Michigan'},
		{value: 'MN', label: 'Minnesota'},
		{value: 'MS', label: 'Mississippi'},
		{value: 'MO', label: 'Missouri'},
		{value: 'MT', label: 'Montana'},
		{value: 'NE', label: 'Nebraska'},
		{value: 'NV', label: 'Nevada'},
		{value: 'NH', label: 'New Hampshire'},
		{value: 'NJ', label: 'New Jersey'},
		{value: 'NM', label: 'New Mexico'},
		{value: 'NY', label: 'New York'},
		{value: 'NC', label: 'North Carolina'},
		{value: 'ND', label: 'North Dakota'},
		{value: 'OH', label: 'Ohio'},
		{value: 'OK', label: 'Oklahoma'},
		{value: 'OR', label: 'Oregon'},
		{value: 'PA', label: 'Pennsylvania'},
		{value: 'PR', label: 'Puerto Rico'},
		{value: 'RI', label: 'Rhode Island'},
		{value: 'SC', label: 'South Carolina'},
		{value: 'SD', label: 'South Dakota'},
		{value: 'TN', label: 'Tennessee'},
		{value: 'TX', label: 'Texas'},
		{value: 'UT', label: 'Utah'},
		{value: 'VT', label: 'Vermont'},
		{value: 'VA', label: 'Virginia'},
		{value: 'WA', label: 'Washington'},
		{value: 'WV', label: 'West Virginia'},
		{value: 'WI', label: 'Wisconsin'},
		{value: 'WY', label: 'Wyoming'}
	]
}, {
	value: 'CAN', label: 'Canada', states: [
		{value: 'AB', label: 'Alberta'},
		{value: 'BC', label: 'British Columbia'},
		{value: 'MB', label: 'Manitoba'},
		{value: 'NB', label: 'New Brunswick'},
		{value: 'NL', label: 'Newfoundland'},
		{value: 'NS', label: 'Nova Scotia'},
		{value: 'NT', label: 'Northwest Territories'},
		{value: 'NU', label: 'Nunavut'},
		{value: 'ON', label: 'Ontario'},
		{value: 'PE', label: 'Prince Edward Island'},
		{value: 'QC', label: 'Quebec'},
		{value: 'SK', label: 'Saskatchewan'},
		{value: 'YT', label: 'Yukon'},
	]
}];

/**
 * Link the relationship between the country and the state selects
 * @param $country {jQuery} countries select
 * @param $stateProvince {jQuery} state select
 */
let countryStateSetup = function ($country, $stateProvince) {
	$.each(countries, function (key, val) {
		$country.append(`<option value="${val.value}">${val.label}</option>`);
	});
	$country.on('change', function () {
		$stateProvince.empty().val('').append(`<option>${translationsService.translate('FormValues.SelectStateProvince')}</option>`);
		$.each(countries, function (outer, outerVal) {
			if (outerVal.value === $country.val()) {
				$.each(outerVal.states, function (inner, innerVal) {
					$stateProvince.append(`<option value="${innerVal.value}">${innerVal.label}</option>`);
				});
			}
		})
	});
};

export function init($country, $stateProvince) {
	countryStateSetup($country, $stateProvince)
}



// WEBPACK FOOTER //
// ./js/PFF/modules/countryStateSetup.ts